<template>

<template-section v-if="!compact" :config="config" :linkName="linkName" :sectionName="sectionName"  @deSelectSection="$emit('deSelectSection')" @selectSection="$emit('selectSection')" @removeSection="$emit('removeSection')">
	<!-- <template v-slot:default> -->
		<h2 v-if="config.drag">Department Links</h2>
		<div class="department-links-section columns" :data-section_hash="config.hash" :class="columnsClass" v-if="!config.drag">
			<div class="department tile" v-for="(department, index) in departments">
				<img :src="department" :key="index"></img>
				<div class="department-label">Department</div>
			</div>
		</div>
	<!-- </template> -->

	<template v-slot:sectionEdit>
		<div class="column span-three columns columns-2">
			<div class="column">
				<h3>Columns</h3>
				<select v-model="columns">
					<option value="1">1</option>
					<option value="2">2</option>
					<option value="3">3</option>
					<option value="4">4</option>
				</select>
				<h3>Rows</h3>
				<p>Your home page will display Department Link rows based on the tiles you select in the Department Links program.</p>
				<a href="/dashboard/website/department-links" target="_blank" class="website-link">Add Department Links</a>
			</div>
			<div class="column">
				<h3>Font Size</h3>
				<select v-model="fontSize">
					<option :value="fontSizeOption" v-for="(fontSizeOption, label) in styleOptions.fontSize" :key="label">
						{{ label }}
					</option>
				</select>
				<h3>Image Style</h3>
				<select  v-model="imageStyle">
					<option value="dark">Dark</option>
					<option value="america">America</option>
					<option value="green">Green</option>
					<option value="blue">Blue</option>
					<option value="brown">Brown</option>
				</select>
			</div>
		</div>
	</template>
</template-section>

<div v-else>Department Links <i class="fas fa-grip-horizontal"></i></div>

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
	name: 'department-links',
	props: ['compact', 'config', 'options'],
	data() {
		return {
			styleOptions: {
				fontSize: {
					"-2": "2.0vw",
					"-1": "2.1vw",
					"Default": "2.2vw",
					"+1": "2.4vw"
				}
			},
			map: {
				'black': 'dark',
				'gold': 'dark',
				'red': 'america',
				'green': 'green',
				'blue': 'blue',
				'brown': 'brown',
				'orange': 'dark'
			},
			linkName: "/website/department-links",
			sectionName: "Department Links"
		}
	},
	created() {
		if (!this.compact && !this.config.hash) {
			console.log(this.config.hash)
			this.hash = [...Array(32)].map(i=>(~~(Math.random()*36)).toString(36)).join('')
		}
	},
	watch: {
		'getTemplateData.siteOptions.colorScheme': {
			handler: function(newVal) {
				this.imageStyle = this.map[newVal]
			}
		}
	},
	computed: {
        ...mapGetters('website_module', [
            'getTemplateData',
            'getTemplateDataChanged'
        ]),
        localIndex() {
			if (this.compact) return
            return this.config.index - 1
        },
		departments() {
			var departments = []
			// for (var i = 0; i < (this.columns * this.rows); i++) {
			for (var i = 0; i < (this.columns); i++) {
				departments.push(`https://s3.us-east-2.amazonaws.com/media.connecteddatasolutions.com/templates/${this.imageStyle}/generic-department-${this.imageStyle}.jpg`)
			}
			return departments
		},
		columns: {
			get() {
				return this.getTemplateData.pageSections[this.localIndex].options.columns
			},
			set(value) {
				this.updateTemplateData({ path: `pageSections[${this.localIndex}].options.columns`, value: value })
			}
		},
		hash: {
			get() {
				return this.getTemplateData.pageSections[this.localIndex].hash
			},
			set(value) {
				this.updateTemplateData({ path: 'pageSections[' + this.localIndex + '].hash', value: value })
				this.updateStyles()
			}
		},
        fontSize: {
            get() {
                return  this.getTemplateData.pageSections[this.localIndex].options.department["font-size"].value ||
                        this.getTemplateData.pageSections[this.localIndex].options.department["font-size"].default
            },
            set(value) {
                this.updateTemplateData({ path: 'pageSections[' + this.localIndex + '].options.department["font-size"].value', value: value })
				this.updateStyles()
            }
        },
		columnsClass() {
			return 'columns-' + this.columns
		},
		imageStyle: {
			get() {
				return this.getTemplateData.pageSections[this.localIndex].options.imageStyle
			},
			set(value) {
				this.updateTemplateData({ path: 'pageSections[' + this.localIndex + '].options.imageStyle', value: value })
			}
		}
	},
	methods: {
        ...mapActions('website_module', [
            'updateTemplateData'
        ]),
		imageSrc(department) {
			if (!department) return
			return `https://s3.us-east-2.amazonaws.com/media.connecteddatasolutions.com/templates/${this.imageStyle}/generic-department-${department.label}-small.jpg`
		},
		updateStyles() {
			var styles = {}
			styles[".department-links-section[data-section_hash='" + this.hash + "'] .department"] = {
				"color": {
					value: null,
					defaultColor: 0
				},
				"font-size": {
					value: this.fontSize,
					default: "2.2vw"
				}
			}
			this.updateTemplateData({ path: 'pageSections[' + this.localIndex + '].options.styles', value: styles })
		}
	}
}
</script>
<style lang="scss" scoped>
</style>
